import { render, staticRenderFns } from "./AnnuityDetailListForInvoice.vue?vue&type=template&id=4db061b2&"
import script from "./AnnuityDetailListForInvoice.vue?vue&type=script&lang=js&"
export * from "./AnnuityDetailListForInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityDetailListForInvoice.vue?vue&type=style&index=0&id=4db061b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports